import { SimulatorItem, SimulatorQuestion } from '@/types';
import SimulatorSteps from '@/components/SimulatorSteps';
import i18n_iso_countries from 'i18n-iso-countries';

function situationQuestion(state: SimulatorSteps): string {
	const today = new Date();
	return state.t('situation.question') +
		today.toLocaleDateString() +
		state.t('situation.endQuestion');
}

function nationalityItems(state: SimulatorSteps): SimulatorItem[] {
	const locale = state.$i18n ? state.$i18n.locale : 'fr';
	const countries = i18n_iso_countries.getNames(locale);
	const items: SimulatorItem[] = [];
	const rmCountries = [
		// Special treatment
		'BL',
		'GF',
		'GP',
		'NC',
		'MF',
		'MQ',
		'PF',
		'PM',
		'RE',
		'TF',
		'WF',
		'YT',

		// Not considered like a country
		'AW',
		'AX',
		'BQ',
		'CK',
		'CW',
		'FO',
		'GF',
		'GI',
		'GL',
		'HK',
		'IO',
		'MO',
		'NU',
		'PN',
		'SH',
		'SX'
	];
	for (const code in countries) {
		if (rmCountries.includes(code)) {
			continue;
		}
		items.push({
			text: countries[code],
			value: code
		});
	}
	items.sort((a, b) => a.text.toString().localeCompare(b.text.toString()));
	return items;
}

export default function getSimulatorQuestions(state: SimulatorSteps): SimulatorQuestion[] {
	const questions: SimulatorQuestion[] = [];
	let key = 'situation';
	questions.push(
		{
			key: key,
			type: 'select',
			title: situationQuestion(state),
			placeholder: state.t(key + '.placeholder'),
			values: [
				{
					text: state.t(key + '.answers.studentWithoutActivity'),
					value: 'studentWithoutActivity'
				},
				{
					text: state.t(key + '.answers.studentWithActivity'),
					value: 'studentWithActivity'
				},
				{
					text: state.t(key + '.answers.doctoralStudent'),
					value: 'doctoralStudent'
				},
				{
					text: state.t(key + '.answers.talentPassport'),
					value: 'talentPassport'
				}
			]
		});
	questions.push(
		{
			key: 'alert',
			type: 'alert',
			title: situationQuestion(state),
			description: state.t(key + '.alert'),
			condition: {
				key: key,
				operator: 'eq',
				value: 'studentWithActivity'
			}
		}
	);
	key = 'doctoralStudent';
	questions.push(
		{
			key: key,
			type: 'radio',
			title: state.t(key + '.question'),
			condition: {
				key: 'situation',
				operator: 'eq',
				value: 'doctoralStudent'
			}
		}
	);
	questions.push(
		{
			key: 'alert',
			type: 'alert',
			title: state.t(key + '.question'),
			description: state.t(key + '.alert'),
			condition:
				{
					key: key,
					operator: 'eq',
					value: 'true'
				}
		}
	);
	key = 'doctoralStudent1';
	questions.push(
		{
			key: key,
			type: 'radio',
			title: state.t(key + '.question'),
			condition:
				{
					key: 'situation',
					operator: 'eq',
					value: 'doctoralStudent'
				}
		}
	);
	questions.push(
		{
			key: 'alert',
			type: 'alert',
			title: state.t(key + '.question'),
			description: state.t(key + '.alert'),
			condition:
				{
					key: key,
					operator: 'eq',
					value: 'true'
				}
		}
	);
	key = 'doctoralStudent2';
	questions.push(
		{
			key: key,
			type: 'radio',
			title: state.t(key + '.question'),
			condition:
				{
					key: 'situation',
					operator: 'eq',
					value: 'doctoralStudent'
				}
		}
	);
	questions.push(
		{
			key: 'alert',
			type: 'alert',
			title: state.t(key + '.question'),
			description: state.t(key + '.alert'),
			condition:
				{
					key: key,
					operator: 'eq',
					value: 'true'
				}
		}
	);
	key = 'doctoralStudent3';
	questions.push(
		{
			key: key,
			type: 'radio',
			title: state.t(key + '.question'),
			condition:
				{
					key: 'situation',
					operator: 'eq',
					value: 'doctoralStudent'
				}
		}
	);
	questions.push(
		{
			key: 'alert',
			type: 'alert',
			title: state.t(key + '.question'),
			description: state.t(key + '.alert'),
			condition:
				{
					key: key,
					operator: 'eq',
					value: 'true'
				}
		}
	);
	key = 'talentPassport';
	questions.push(
		{
			key: key,
			type: 'radio',
			title: state.t(key + '.questionStudent'),
			condition:
				{
					key: 'situation',
					operator: 'eq',
					value: 'talentPassport'
				}

		}
	);
	questions.push(
		{
			key: 'alert',
			type: 'alert',
			title: state.t(key + '.question'),
			description: state.t(key + '.alertWithoutActivity'),
			condition:
				{
					key: key,
					operator: 'eq',
					value: 'false'
				}

		}
	);
	questions.push(
		{
			key: 'question-employee',
			type: 'radio',
			title: state.t(key + '.questionEmployee'),
			condition: {
				key: key,
				operator: 'eq',
				value: 'true'
			}
		}
	);
	questions.push(
		{
			key: 'alert',
			type: 'alert',
			title: state.t(key + '.questionEmployee'),
			description: state.t(key + '.alertWithActivity'),
			condition:
				{
					key: 'question-employee',
					operator: 'eq',
					value: 'true'
				}

		}
	);
	key = 'birthdate';
	questions.push(
		{
			key: key,
			type: 'date',
			title: state.t(key + '.question'),
			placeholder: state.t(key + '.placeholder')
		});
	key = 'nationality';
	questions.push(
		{
			key: key,
			type: 'select',
			title: state.t(key + '.question'),
			placeholder: state.t(key + '.placeholder'),
			values: nationalityItems(state)
		});
	return questions;
}
